export const safeParse = <T>(text: string, fallbackValue: T) => {
    try {
        return JSON.parse(text) as T;
    } catch {
        return fallbackValue;
    }
};
